module.exports = __webpack_public_path__ + "static/Discord-2b7a4f22cb863d591a5c8e1aae8a0b0c.jpg";